var React = require('react');

function Cloud3 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_2-2","data-name":"Layer 2"},React.createElement("path",{"className":"cls-1","d":"M129.41,284.69C-9.83,284.69-28.86,171.41,35,107.55,97.64,44.91,151.4,82.7,194.76,40.16c57.36-56,157.17-53.55,207,8.12,15.39,19,28.85,34.41,50.8,42.49a85.29,85.29,0,0,0,19.81,4.4c34.3,4,35.78,15.27,67.78,47.27.58.58,55.42,26.42,56,27,36.5,36.5-4,109-49.06,109"})))]);
}

Cloud3.defaultProps = {"viewBox":"0 0 610.32 284.69"};

module.exports = Cloud3;

Cloud3.default = Cloud3;
